import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getInformation } from '../features/information/informationSlice';
import Modal from '../components/Modal';

const Information = () => {
  const dispatch = useDispatch();
  const { information, isLoading } = useSelector((state) => state.information);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedInfo, setSelectedInfo] = useState(null);
  const itemsPerPage = 5;

  useEffect(() => {
    dispatch(getInformation());
  }, [dispatch]);

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = information.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(information.length / itemsPerPage);

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="py-12">
      <section className="container mx-auto px-4">
        <div className="mb-10">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Informasi</h1>
          <p className="text-gray-500">Informasi penting tentang Penerbit Literasiologi</p>
        </div>

        {isLoading ? (
          <div className="space-y-4">
            {Array(5).fill(0).map((_, index) => (
              <div key={index} className="bg-white rounded-2xl border border-gray-200 p-6">
                <div className="skeleton h-6 w-3/4 rounded-lg mb-4"></div>
                <div className="skeleton h-4 w-full rounded-lg mb-2"></div>
              </div>
            ))}
          </div>
        ) : information.length > 0 ? (
          <>
            <div className="space-y-4">
              {currentItems.map((info) => (
                <div key={info._id} className="bg-white rounded-2xl border border-gray-200 p-6 hover:shadow-lg cursor-pointer transition-all" onClick={() => setSelectedInfo(info)}>
                  <div className="flex items-start justify-between mb-3">
                    <h3 className="text-xl font-semibold text-gray-900">{info.title}</h3>
                    <span className="px-3 py-1 bg-dark-blue-50 text-dark-blue-700 rounded-full text-sm font-medium">
                      {info.type}
                    </span>
                  </div>
                  <p className="text-gray-600 text-sm">Klik untuk melihat detail</p>
                </div>
              ))}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="flex justify-center items-center gap-2 mt-12">
                <button
                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                  className="px-4 py-2 border border-gray-200 rounded-xl hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  Sebelumnya
                </button>
                {pageNumbers.map(number => (
                  <button
                    key={number}
                    onClick={() => setCurrentPage(number)}
                    className={`px-4 py-2 rounded-xl font-medium transition-colors ${
                      currentPage === number
                        ? 'bg-dark-blue-700 text-white'
                        : 'border border-gray-200 hover:bg-gray-50'
                    }`}
                  >
                    {number}
                  </button>
                ))}
                <button
                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages}
                  className="px-4 py-2 border border-gray-200 rounded-xl hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  Selanjutnya
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="text-center py-20">
            <div className="w-20 h-20 bg-gray-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-700 mb-2">Belum ada informasi</h3>
            <p className="text-gray-500">Informasi akan segera ditampilkan</p>
          </div>
        )}
      </section>

      {/* Modal Detail Informasi */}
      {selectedInfo && (
        <Modal
          isOpen={!!selectedInfo}
          onClose={() => setSelectedInfo(null)}
          title={selectedInfo.title}
        >
          <div className="mb-4">
            <span className="px-3 py-1 bg-dark-blue-50 text-dark-blue-700 rounded-full text-sm font-medium">
              {selectedInfo.type}
            </span>
          </div>
          <div className="text-gray-600 leading-relaxed prose-content" dangerouslySetInnerHTML={{ __html: selectedInfo.content }} />
        </Modal>
      )}
    </div>
  );
};

export default Information;
